import ReservationMixin from '../../../mixin/tickets'

import Timeslot from './timeslot'

const components = {
  Timeslot,
}

export default {
  name: 'timeslot-selector-box',

  mixins: [ReservationMixin],
  components,
  data() {
    return {

    }
  },
  computed: {
    hasSelectedSlot() {
      return !_.isEmpty(this.selectedSlots)
    },
    allSlots() {
      return this.retrievedTimeslots
    },
    numRetrievedSlots() {
      return _.values(this.allSlots).length
    },
    noRetrievedSlots() {
      return _.isEmpty(this.allSlots)
    },
    selectableSlots() {
      return this.visibleSlots
    },
    numSelectableSlots() {
      return _.values(this.selectableSlots).length
    },
    noSelectableSlots() {
      return _.isEmpty(this.selectableSlots)
    },

  },
  watch: {
  },
  created() {

  },
  methods: {

  },

}
